<template>
  <div id="app">
    <Nav></Nav>
    <router-view />
    <Copyright></Copyright>
  </div>
</template>

<script>
import Nav from './components/Nav.vue'
import Copyright from './components/Copyright.vue'

export default {
  data() {
    return {
      router: true,
      defaultActive: '/',
      isShow: false,
    }
  },
  components: {
    Copyright,
    Nav,
  },
  methods: {
    handleSelect(key) {
      this.isShow = this.defaultActive != key
      window.console.log(this.isShow)
    },
  },
}
</script>

<style lang="scss">
* {
  padding: 0;
  margin: 0;
}

html,
body {
  height: 100vw;
  overflow-x: hidden;
  height: fit-content;
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

.el-header {
  display: flex;
  justify-content: space-between;
  align-content: center;
  width: 1400px;
  margin: 0 auto;
  //background-color: #fff;

  .logo {
    width: 280px;

    img {
      width: 100%;
      line-height: 60px;
    }
  }
}

.el-main {
  padding: 0 !important;
}

.footer {
  width: 100%;
  overflow: hidden;
  background-color: #fff;

  &-content {
    width: 1400px;
    margin: 0 auto;
    padding: 90px 0 80px;
    display: flex;
    justify-content: space-between;
    border-top: 2px solid #dadada;

    .content-nav {
      display: flex;
      justify-content: space-around;
      align-items: center;
      width: 100%;

      li {
        display: flex;
        flex-direction: column;
        padding: 0 20px;
        //justify-content: center;
        align-items: flex-start;

        p {
          font-size: 20px;
          font-family: PingFang SC-Semibold, PingFang SC;
          font-weight: 600;
          color: #302e2e;
          line-height: 42px;
          letter-spacing: 2px;
        }

        span {
          width: 287px;
          height: 33px;
          font-size: 16px;
          font-family: PingFang SC-Semibold, PingFang SC;
          font-weight: 600;
          color: #504444;
          line-height: 33px;
          letter-spacing: 1px;
        }
      }
    }

    img {
      width: 170px;
      height: 170px;
    }

    .scan {
      // margin-top: 18px;
      text-align: center;
      font-size: 10px;
      font-family: PingFang SC-Semibold, PingFang SC;
      font-weight: 600;
      color: #504444;
      line-height: 21px;
      letter-spacing: 1px;
    }
  }
}

.el-menu--horizontal .el-menu-item {
  font-size: 18px !important;
}

.el-menu.el-menu--horizontal {
  border-bottom: none !important;
}
</style>
